module.exports = __webpack_public_path__ + "src/assets/img/page3/23a3f0f777eb9e9e024e236cae25c335.png";